import React from 'react';
import { TrustedByAttributes } from '@app/models/dtos/strapi';
import SwiperComponent from '@app/components/swiper';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import { useBreakpoint } from '@app/lib/hooks/use-breakpoint';

function TrustedBy({ trustedBy }: { trustedBy: TrustedByAttributes }) {
    const screenSize = useBreakpoint();
    const getSlidesPerView = () => {
        if (['2xl', 'xl', 'lg'].indexOf(screenSize) !== -1) {
            return 4;
        } else if (['md'].indexOf(screenSize) !== -1) {
            return 3;
        } else if (['sm'].indexOf(screenSize) !== -1) {
            return 2;
        } else {
            return 1;
        }
    };
    const SwiperItem = ({ image }: { image: string }) => (
        <div className="flex h-full max-h-[110px] w-full  items-center justify-center">
            <ImageRenderer className="max-h-[110px] max-w-[200px] !object-contain filter-none" media={image} isGrayScale={false} />
        </div>
    );
    return (
        <div className="flex w-full flex-col items-center">
            <div className="mb-[80px] flex w-full flex-col items-center md:mb-[160px]">
                <div className="container w-full">
                    {trustedBy.supports && (
                        <>
                            <p className="P2  mb-10 !text-black-1 ">Trusted By</p>

                            <SwiperComponent
                                items={trustedBy.supports.map((support) => (
                                    <SwiperItem key={support.id} image={`${environments.STRAPI_HOST_URL}${support.url}`} />
                                ))}
                                slidesPerView={getSlidesPerView()}
                                spaceBetween={180}
                            />
                        </>
                    )}
                </div>
            </div>
            <div className="flex w-full justify-center  bg-blue-opacity">
                <div className="container flex w-full flex-col justify-center gap-[50px] py-8 md:flex-row md:gap-[233px]">
                    <div className="flex flex-col items-center gap-6 !text-black-1">
                        <h1 className="h1-responsive">{trustedBy.yearsOfOperation}+</h1>
                        <p className="P2 text-black-2">Years of Operation</p>
                    </div>
                    <div className="flex flex-col items-center gap-6 !text-black-1">
                        <h1 className="h1-responsive">{trustedBy.projects}+</h1>
                        <p className="P2 text-black-2">Project Delivered</p>
                    </div>
                    <div className="flex flex-col items-center gap-6 !text-black-1">
                        <h1 className="h1-responsive">{trustedBy.clients}+</h1>
                        <p className="P2 text-black-2">Satisfied Clients</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrustedBy;
